export const API_URL = process.env.REACT_APP_API_URL as string;
export const WS_URL = process.env.REACT_APP_WS_URL as string;

// Iframe Configuration
export const IFRAME_CONFIG = {
    // Current app origin - dynamically determined
    getCurrentOrigin: () => window.location.origin,

    // Trusted parent origins for iframe communication
    trustedParentOrigins: ["https://callondoc.com", "https://www.callondoc.com"],

    // Message types for iframe communication
    messageTypes: {
        TOKEN_TO_PARENT: "doctusmind-token",
        TOKEN_FROM_PARENT: "inject-token",
        REQUEST_TOKEN: "request-token",
    },

    // Check if running in an iframe
    isInIframe: () => {
        try {
            return window.self !== window.top;
        } catch (e) {
            return true; // If we can't access window.top, we're likely in an iframe
        }
    },

    // Validate if origin is trusted with enhanced security
    isTrustedOrigin: (origin: string) => {
        // For now, allow all domains. In production, this should be validated server-side
        return true;
        // Basic inclusion check
        // if (IFRAME_CONFIG.trustedParentOrigins.includes(origin)) {
        //   return true;
        // }

        // // Additional validation for development environments
        // try {
        //   const url = new URL(origin);
        //   const hostname = url.hostname;

        //   // Allow localhost variations in development
        //   if (hostname === 'localhost' || hostname === '127.0.0.1') {
        //     return IFRAME_CONFIG.trustedParentOrigins.some(trustedOrigin => {
        //       try {
        //         const trustedUrl = new URL(trustedOrigin);
        //         return trustedUrl.hostname === hostname;
        //       } catch {
        //         return false;
        //       }
        //     });
        //   }

        //   return false;
        // } catch (error) {
        //   console.error('[IFRAME_CONFIG] Error validating origin:', error);
        //   return false;
        // }
    },

    // Additional security validation for message contents
    validateMessageSecurity: (message: any, origin: string) => {
        // Check if message has required security fields
        if (!message || typeof message !== "object") {
            return false;
        }

        // Validate timestamp (prevent replay attacks)
        if (message.timestamp) {
            const messageAge = Date.now() - message.timestamp;
            if (messageAge > 60000) {
                // 1 minute max age
                console.warn("[IFRAME_CONFIG] Message too old, possible replay attack");
                return false;
            }
        }

        // Validate origin matches message origin claim
        // if (message.origin && message.origin !== origin) {
        //     console.warn("[IFRAME_CONFIG] Origin mismatch in message");
        //     return false;
        // }

        return true;
    },
};

export const US_STATES_CHOICE = [
    { code: "AL", name: "Alabama" },
    { code: "AK", name: "Alaska" },
    { code: "AZ", name: "Arizona" },
    { code: "AR", name: "Arkansas" },
    { code: "CA", name: "California" },
    { code: "CO", name: "Colorado" },
    { code: "CT", name: "Connecticut" },
    { code: "DE", name: "Delaware" },
    { code: "FL", name: "Florida" },
    { code: "GA", name: "Georgia" },
    { code: "HI", name: "Hawaii" },
    { code: "ID", name: "Idaho" },
    { code: "IL", name: "Illinois" },
    { code: "IN", name: "Indiana" },
    { code: "IA", name: "Iowa" },
    { code: "KS", name: "Kansas" },
    { code: "KY", name: "Kentucky" },
    { code: "LA", name: "Louisiana" },
    { code: "ME", name: "Maine" },
    { code: "MD", name: "Maryland" },
    { code: "MA", name: "Massachusetts" },
    { code: "MI", name: "Michigan" },
    { code: "MN", name: "Minnesota" },
    { code: "MS", name: "Mississippi" },
    { code: "MO", name: "Missouri" },
    { code: "MT", name: "Montana" },
    { code: "NE", name: "Nebraska" },
    { code: "NV", name: "Nevada" },
    { code: "NH", name: "New Hampshire" },
    { code: "NJ", name: "New Jersey" },
    { code: "NM", name: "New Mexico" },
    { code: "NY", name: "New York" },
    { code: "NC", name: "North Carolina" },
    { code: "ND", name: "North Dakota" },
    { code: "OH", name: "Ohio" },
    { code: "OK", name: "Oklahoma" },
    { code: "OR", name: "Oregon" },
    { code: "PA", name: "Pennsylvania" },
    { code: "RI", name: "Rhode Island" },
    { code: "SC", name: "South Carolina" },
    { code: "SD", name: "South Dakota" },
    { code: "TN", name: "Tennessee" },
    { code: "TX", name: "Texas" },
    { code: "UT", name: "Utah" },
    { code: "VT", name: "Vermont" },
    { code: "VA", name: "Virginia" },
    { code: "WA", name: "Washington" },
    { code: "WV", name: "West Virginia" },
    { code: "WI", name: "Wisconsin" },
    { code: "WY", name: "Wyoming" },
];

export const feedback_tags = [
    "Up to date",
    "Accurate",
    "Followed Instructions",
    "Good Sources",
    "Helpful",
    "Clear"
];

// ─── Auth Recovery Timing ─────────────────────────────────────────────────────
/** Milliseconds before showing "Reconnecting…" warning in chat and a warning toast */
export const AUTH_CONNECTING_THRESHOLD_MS = 15000;
/** Milliseconds before declaring failure, showing persistent error toast + Sentry log */
export const AUTH_FAILURE_THRESHOLD_MS = 25000;

export const screens = {
    home: "home_screen",
    setting: "setting_screen",
    about: "about_screen",
    contact:"contact_screen",
    privacy:"privacy_screen",
    create_project: "create_project_screen",
    list_project: "project_list_screen",
    profile: "profile_screen",
    login: "login_screen",
    launch: "launch_screen",
  };

export const professionalCredentials = [
    { label: "MD", value: "MD" },
    { label: "DO", value: "DO" },
    { label: "NP", value: "NP" },
    { label: "PA", value: "PA" },
    { label: "RN", value: "RN" },
    { label: "Pharmacist", value: "Pharmacist" },
    { label: "Other", value: "Other" },
  ];

export const speciality = [
    { label: "Family Medicine (General Practice)", value: "Family_Medicine_General_Practice" },
    { label: "Internal Medicine", value: "Internal_Medicine" },
    { label: "General Practice", value: "General_Practice" },
    { label: "Pediatrics", value: "Pediatrics" },
    { label: "Geriatrics", value: "Geriatrics" },
    { label: "Emergency Medicine", value: "Emergency_Medicine" },
    { label: "Urgent Care Medicine", value: "Urgent_Care_Medicine" },
    { label: "Cardiology", value: "Cardiology" },
    { label: "Endocrinology", value: "Endocrinology" },
    { label: "Gastroenterology", value: "Gastroenterology" },
    { label: "Hematology", value: "Hematology" },
    { label: "Infectious Disease", value: "Infectious_Disease" },
    { label: "Nephrology", value: "Nephrology" },
    { label: "Oncology / Hematology-Oncology", value: "Oncology_Hematology_Oncology" },
    { label: "Pulmonology", value: "Pulmonology" },
    { label: "Rheumatology", value: "Rheumatology" },
    { label: "Urgent Care Medicine", value: "Urgent_Care_Medicine" },
    { label: "General Surgery", value: "General_Surgery" },
    { label: "Orthopedic Surgery", value: "Orthopedic_Surgery" },
    { label: "Neurosurgery", value: "Neurosurgery" },
    { label: "Cardiothoracic Surgery", value: "Cardiothoracic_Surgery" },
    { label: "Plastic & Reconstructive Surgery", value: "Plastic_Reconstructive_Surgery" },
    { label: "Urology", value: "Urology" },
    { label: "Vascular Surgery", value: "Vascular_Surgery" },
    { label: "Otolaryngology (ENT)", value: "Otolaryngology_ENT" },
    { label: "Ophthalmology", value: "Ophthalmology" },
    { label: "Obstetrics & Gynecology (OB/GYN)", value: "Obstetrics_Gynecology_OB_GYN" },
    { label: "Neonatology", value: "Neonatology" },
    { label: "Pediatric Subspecialties", value: "Pediatric_Subspecialties" },
    { label: "Psychiatry", value: "Psychiatry" },
    { label: "Child & Adolescent Psychiatry", value: "Child_Adolescent_Psychiatry" },
    { label: "Psychology", value: "Psychology" },
    { label: "Counseling / Therapy", value: "Counseling_Therapy" },
    { label: "Dermatology", value: "Dermatology" },
    { label: "Anesthesiology", value: "Anesthesiology" },
    { label: "Radiology (Diagnostic & Interventional)", value: "Radiology_Diagnostic_Interventional" },
    { label: "Pathology", value: "Pathology" },
    { label: "Physical Medicine & Rehabilitation (PM&R)", value: "Physical_Medicine_Rehabilitation_PM&R" },
    { label: "Allergy & Immunology", value: "Allergy_Immunology" },
    { label: "Nurse Practitioner (NP) – Family", value: "Nurse_Practitioner_NP_Family" },
    { label: "Nurse Practitioner (NP) – Adult-Gerontology", value: "Nurse_Practitioner_NP_Adult_Gerontology" },
    { label: "Nurse Practitioner (NP) – Pediatrics", value: "Nurse_Practitioner_NP_Pediatrics" },
    { label: "Physician Assistant (PA)", value: "Physician_Assistant_PA" },
    { label: "Certified Nurse Midwife (CNM)", value: "Certified_Nurse_Midwife_CNM" },
    { label: "Clinical Nurse Specialist (CNS)", value: "Clinical_Nurse_Specialist_CNS" },
    { label: "Other", value: "Other" },
  ];

  export const country = [
    { label: "United States", value: "United_States" },
    { label: "Canada", value: "Canada" },
    { label: "Mexico", value: "Mexico" },
    { label: "Brazil", value: "Brazil" },
    { label: "Argentina", value: "Argentina" },
    { label: "United Kingdom", value: "United_Kingdom" },
    { label: "Germany", value: "Germany" },
    { label: "France", value: "France" },
    { label: "Italy", value: "Italy" },
    { label: "Spain", value: "Spain" },
    { label: "Russia", value: "Russia" },
    { label: "China", value: "China" },
    { label: "India", value: "India" },
    { label: "Japan", value: "Japan" },
    { label: "South Korea", value: "South_Korea" },
    { label: "Australia", value: "Australia" },
    { label: "New Zealand", value: "New_Zealand" },
    { label: "South Africa", value: "South_Africa" },
    { label: "Nigeria", value: "Nigeria" },
    { label: "Egypt", value: "Egypt" },
    { label: "Saudi Arabia", value: "Saudi_Arabia" },
    { label: "Turkey", value: "Turkey" },
    { label: "United Arab Emirates", value: "United_Arab_Emirates" },
    { label: "Singapore", value: "Singapore" },
    { label: "Thailand", value: "Thailand" },
    { label: "Indonesia", value: "Indonesia" },
    { label: "Pakistan", value: "Pakistan" },
    { label: "Bangladesh", value: "Bangladesh" },
    { label: "Vietnam", value: "Vietnam" },
  ];

  export const stateCode = [
    { "label": "Alabama", "value": "AL" },
    { "label": "Alaska", "value": "AK" },
    { "label": "Arizona", "value": "AZ" },
    { "label": "Arkansas", "value": "AR" },
    { "label": "California", "value": "CA" },
    { "label": "Colorado", "value": "CO" },
    { "label": "Connecticut", "value": "CT" },
    { "label": "Delaware", "value": "DE" },
    { "label": "Florida", "value": "FL" },
    { "label": "Georgia", "value": "GA" },
    { "label": "Hawaii", "value": "HI" },
    { "label": "Idaho", "value": "ID" },
    { "label": "Illinois", "value": "IL" },
    { "label": "Indiana", "value": "IN" },
    { "label": "Iowa", "value": "IA" },
    { "label": "Kansas", "value": "KS" },
    { "label": "Kentucky", "value": "KY" },
    { "label": "Louisiana", "value": "LA" },
    { "label": "Maine", "value": "ME" },
    { "label": "Maryland", "value": "MD" },
    { "label": "Massachusetts", "value": "MA" },
    { "label": "Michigan", "value": "MI" },
    { "label": "Minnesota", "value": "MN" },
    { "label": "Mississippi", "value": "MS" },
    { "label": "Missouri", "value": "MO" },
    { "label": "Montana", "value": "MT" },
    { "label": "Nebraska", "value": "NE" },
    { "label": "Nevada", "value": "NV" },
    { "label": "New Hampshire", "value": "NH" },
    { "label": "New Jersey", "value": "NJ" },
    { "label": "New Mexico", "value": "NM" },
    { "label": "New York", "value": "NY" },
    { "label": "North Carolina", "value": "NC" },
    { "label": "North Dakota", "value": "ND" },
    { "label": "Ohio", "value": "OH" },
    { "label": "Oklahoma", "value": "OK" },
    { "label": "Oregon", "value": "OR" },
    { "label": "Pennsylvania", "value": "PA" },
    { "label": "Rhode Island", "value": "RI" },
    { "label": "South Carolina", "value": "SC" },
    { "label": "South Dakota", "value": "SD" },
    { "label": "Tennessee", "value": "TN" },
    { "label": "Texas", "value": "TX" },
    { "label": "Utah", "value": "UT" },
    { "label": "Vermont", "value": "VT" },
    { "label": "Virginia", "value": "VA" },
    { "label": "Washington", "value": "WA" },
    { "label": "West Virginia", "value": "WV" },
    { "label": "Wisconsin", "value": "WI" },
    { "label": "Wyoming", "value": "WY" }
  ]

  export const raceAndEthnicity = [
    { label: "White or Caucasion", value: "White_or_Caucasion" },
    { label: "American Indian or Alaska Native", value: "American_Indian_or_Alaska_Native" },
    { label: "Asian", value: "Asian" },
    { label: "Black or African American", value: "Black_or_African_American" },
    { label: "Prefer not to say", value: "Prefer_not_to_say" },
  ];

  export const gender = [
    { label: "Male", value: "Male" },
    { label: "Female", value: "Female" },
    { label: "Prefer not to say", value: "NOT_STATED" },
  ];

  export const pronouns = [
    { label: "He/Him", value: "He" },
    { label: "She/Her", value: "She" },
    { label: "They/Them", value: "they" },
  ];

  export interface OtherProfileData {
    pronouns: string; 
    country_of_Residence: string;
    location_pin_code: string;
    race_ethnicity: string;
    preferred_language: string;
  }


  export const languageOptions = [
    { label: "English", value: "English" },
    { label: "Tamil", value: "Tamil" },
    { label: "Hindi", value: "Hindi" },
  ];